var map = {
	"./de/cv-play.png": "qb3h",
	"./en/cv-play.png": "iz9I",
	"./es/cv-play.png": "jYU9",
	"./fr/cv-play.png": "J9CW",
	"./ja/cv-play.png": "Hek+",
	"./ko/cv-play.png": "jCbm",
	"./pt/cv-play.png": "rTR7",
	"./ru/cv-play.png": "mazc",
	"./tc/cv-play.png": "Twjr",
	"./th/cv-play.png": "eFr9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Xgs6";